import LoginComponent from "../../components/LoginComponent";
import SEO from "../../components/SEO";
import { pageSEOData } from "../../data/seoData";

const LoginPage: React.FC = () => {
  const seo = pageSEOData.login;

  return (
    <div className="page-animation">
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        ogImage={seo.ogImage}
        noIndex={true}
      />
      <LoginComponent />
    </div>
  );
};

export default LoginPage;
